// currently support single quote per page
// not feeling good about it, only if had more time
var ps_quote_animation = document.querySelector(".ps_quote_animation");
var ps_quote_animation_height = isNaN(window.innerHeight)
  ? window.clientHeight
  : window.innerHeight;
var ps_quote_animation_div_height = 0;
// Initial state
var ps_quote_animation_scrollPos = 0;
var ps_quote_animation_scrollDir = "";
var ps_quote_animation_filled_text = 0;

if (ps_quote_animation) {
  var ps_quote_animation_textlength = ps_quote_animation.innerHTML.length;
  var ps_quote_animation_text = ps_quote_animation.innerHTML;
  ps_quote_animation_div_height = ps_quote_animation.scrollHeight + 200;

  gsap.registerPlugin(ScrollTrigger);

  // pin box-c when it reaches the center of the viewport, for 300px
  ScrollTrigger.create({
    trigger: ".ps_quote_animation",
    pin: true,
    start: "center center",
	scrub: 0.1,
    end: "+=" + ps_quote_animation_div_height,
    markers: false,
  //  onToggle: (self) => console.log("toggled, isActive:", self.isActive),
    onUpdate: (self) => {
		// these are some sample variable which we can use
	//	console.log("progress:", self.progress.toFixed(3), "direction:", self.direction, "velocity", self.getVelocity());
      updateQuoteColors(
        ps_quote_animation_textlength * self.progress.toFixed(3),
        ps_quote_animation,
        ps_quote_animation_text
      );
    },
  });


}
// updating quote content
function updateQuoteColors(point, ps_quote_animation, ps_quote_animation_text) {
  if (point < 0) {
    return;
  }

  var newText = "";
  for (var i = 0; i < ps_quote_animation_text.length; i++) {
    if (i < point) {
      newText +=
        '<span class="color1">' + ps_quote_animation_text[i] + "</span>";
    } else if (i >= point && i <= point + 10) {
      newText +=
        '<span class="color2">' + ps_quote_animation_text[i] + "</span>";
    } else {
      newText +=
        '<span class="color3">' + ps_quote_animation_text[i] + "</span>";
    }
  }
  ps_quote_animation.innerHTML = newText;
}
